<div class="slds-form-element">
  <div class="slds-form-element__control">
    <div class="slds-select_container">
      <select class="slds-select" id="select">
        <option value="">Please select</option>
        <option>Edit Document</option>
        <option>Data Binding</option>
        <option>Salesforce Annotations</option>
      </select>
    </div>
  </div>
</div>
